var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,11.41L6.34,5.76l1.41-1.41,3.24,3.24V2h2V7.59l3.24-3.24,1.41,1.41-5.66,5.66Zm-5.66,7.83l1.41,1.41,3.24-3.24v5.59h2v-5.59l3.24,3.24,1.41-1.41-5.66-5.66-5.66,5.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/1765206080/media/icon-close.619d9578ddc25aec64a2f862ea6ec451.svg";
export { ForwardRef as ReactComponent };